import React from 'react';
import SpecificComponent from '../../commons/SpecificComponent'
import AppBar from '../../commons/AppBar'
import SegmentButtons from '../../commons/SegmentButtons'
import InformatiiProiect from './InformatiiProiect'
import EtapeProiect from './EtapeProiect'
import Taskuri from './Taskuri'
import { Button, Hidden, FormControl, InputLabel, Select, Input, MenuItem } from '@material-ui/core';
import Commons from '../../commons/Commons';
import Drepturi from './Drepturi'
import BugeteProiecte from './BugeteProiecte'
import DocumenteProiecte from './DocumenteProiecte';
import RapoarteProiect from './RapoarteProiect';
import AI from './AI';
import Utils from '../../providers/Utils';

export default class DetaliiProiect extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
           segmentButtons: this.generateSegmentButtons(),
          fullScreen:false,
          selectedSegment:Number(this.props.match.params.projectsegment)
 
        }          
    }


    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }



    dataAzi = () => {
        let u = new Utils()

        let dataAzi = u.defaultData()

        if (this.dictionary.date === 'en') {
            return u.dataPrescurtataEng(dataAzi)
        } else {
            return u.dataPrescurtataRomana(dataAzi)
        }
    }
    

    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }

    generateSegmentButtons = ()=>{


    if(window.innerWidth <= 800){

        return [
            {
                text:this.dictionary.proiecte.segmentButtons.informatii,
                idx:0,
                
            },
            {
                text:this.dictionary.proiecte.segmentButtons.etape,
                idx:1,
            },
            // {
            //     text:this.dictionary.proiecte.segmentButtons.taskuri,
            //     idx:this.selectedSegment
            // },
            {
                text:this.dictionary.proiecte.segmentButtons.drepturi,
                idx:2
            },
            {
                text:this.dictionary.proiecte.segmentButtons.costuri,
                idx:3
            },
            {
                text:this.dictionary.proiecte.segmentButtons.documente,
                idx:4
            },
            {
                text:this.dictionary.proiecte.segmentButtons.rapoarte,
                idx:5
            },
            {
                text:'AI',
                idx:6
            }
        ]

    }else{
        return [
            {
                text:this.dictionary.proiecte.segmentButtons.informatii,
                onSegButClick:this.selectedSegment,
                
            },
            {
                text:this.dictionary.proiecte.segmentButtons.etape,
                onSegButClick:this.selectedSegment,
            },
            // {
            //     text:this.dictionary.proiecte.segmentButtons.taskuri,
            //     onSegButClick:this.selectedSegment
            // },
            {
                text:this.dictionary.proiecte.segmentButtons.drepturi,
                onSegButClick:this.selectedSegment
            },
            {
                text:this.dictionary.proiecte.segmentButtons.costuri,
                onSegButClick:this.selectedSegment
            },
            {
                text:this.dictionary.proiecte.segmentButtons.documente,
                onSegButClick:this.selectedSegment
            },
            {
                text:this.dictionary.proiecte.segmentButtons.rapoarte,
                onSegButClick:this.selectedSegment
            },
            {
                text:'AI',
                onSegButClick:this.selectedSegment
            }
        ]
    }

      

    }

    selectedSegment = (s) =>{
        // console.log('s :', s.target);
        // console.log('object :', Number(this.props.match.params.projectsegment));
        this.setState({selectedSegment:s},()=>{
            this.props.history.push(`/projectdetails/${this.props.match.params.projectid}/${s}`)
        })

    }

     componentDidMount(){
      this.getWindowDimentions()
    }
     render() { 
       return (
          <div>
              <AppBar history={this.props.history} title={' '}   appBarButtons={this.buildAppBarButtons()}/>
            
            {/* {this.state.fullScreen ? 
            <div style={{textAlign:'center'}}>
                <FormControl className='inputFocus' style={{ width: '90%', marginTop:16 }}>
                                    <InputLabel htmlFor="resursa">Navigator</InputLabel>
                                    <Select
                                        value={this.state.selectedSegment}
                                        onChange={(ev)=>{this.selectedSegment(ev.target.value)}}

                                        input={<Input id="resursa" />}>


                                        {this.state.segmentButtons.map((s, idx) => {
                                            return <MenuItem value={s.idx} key={idx}  > {s.text}</MenuItem>

                                        })
                                        }
                                    </Select>
                                </FormControl>

            </div>
        :
        
        
              <SegmentButtons buttons={this.state.segmentButtons} selectedIndexButton={Number(this.props.match.params.projectsegment)} />
        } */}

          
    {Number(this.props.match.params.projectsegment) === 0 && 
        <InformatiiProiect history={this.props.history} idproiect={this.props.match.params.projectid}/>
    }

    {Number(this.props.match.params.projectsegment)=== 1 && 
        <EtapeProiect idproiect={this.props.match.params.projectid} history={this.props.history}/>
    }

    {/* {this.state.selectedSegment === 2 && 
        <Taskuri idproiect={this.props.match.params.projectid}/>
    } */}
    
        {Number(this.props.match.params.projectsegment) === 2 && 
            <Drepturi idproiect={this.props.match.params.projectid}/>
        }

        {Number(this.props.match.params.projectsegment) === 3 && 
            <BugeteProiecte idproiect={this.props.match.params.projectid}/>
        }

        {Number(this.props.match.params.projectsegment) === 4 && 
            <DocumenteProiecte idproiect={this.props.match.params.projectid}/>
        }

        {Number(this.props.match.params.projectsegment) === 5 && 
        
            <RapoarteProiect idproiect={this.props.match.params.projectid}/>
        }

        {Number(this.props.match.params.projectsegment) === 6 && 
        
            <AI idproiect = {this.props.match.params.projectid} />
        }





            
         </div>
        );
       }
}